export default {
  // Page Title
  pageTitle: "Address Monitoring",

  // Buttons
  addMonitor: "Add Monitor",
  finish: "Finish",
  reset: "Reset",
  query: "Query",
  view: "View",
  modify: "Modify",
  confirm: "Confirm",
  cancel: "Cancel",
  yes: "Yes",
  no: "No",

  // Input Placeholders
  inputMonitorName: "Enter monitor name",
  inputMonitorAddress: "Enter monitor address",
  selectRelatedCase: "Select related case",
  selectCurrency: "Select currency",

  // Title Information
  totalMonitors: "address monitors",
  monitoring: "Monitoring",
  totalCount: "item(s)",
  hideStoppedData: "Hide paused monitoring data",

  // Monitor Types
  commonMonitor: "Common Monitor",
  realtimeMonitor: "Real-time Monitor",

  // Monitor Information
  monitorName: "Monitor Name",
  address: "Address",
  relatedCase: "Related Case",
  condition: "Condition",
  remark: "Remark",
  monitorDynamics: "monitor dynamics",
  unread: "unread",

  // Dialog Titles
  dialogAddMonitor: "Add Monitor",
  dialogModify: "Modify",
  dialogDingTalkHelp: "DingTalk Robot Setup Instructions",

  // Messages
  noData: "No data available",
  loading: "Loading...",
  copySuccess: "Copied successfully!",
  modifySuccess: "Modified successfully",
  deleteSuccess: "Monitor deleted successfully",
  deleteCancel: "Delete cancelled",

  // Confirmation Dialogs
  confirmDelete: "This operation will permanently delete this file. Continue?",
  confirmStop: "Change status to",
  stopMonitor: "Stop Monitor",
  openMonitor: "Open Monitor",
  closeSuccess: "Closed successfully",

  // Detail Page
  detailTitle: "Details",
  transferIn: "Transfer In",
  transferOut: "Transfer Out",
  amount: "Amount",
  time: "Time",
  hash: "Hash",

  // Tips
  tip: "Tips",
  multiChainTip:
    "The current address has multiple chain transaction data, please select the corresponding chain below for analysis",
};
